import React from "react";
import { Reveal, StaggerReveal, Eyebrow } from "../ui";

const stepData = [
  {
    num: "01",
    title: "Create your profile",
    desc: "Add your photo, occupation, and bio. The more you share, the better your connections.",
  },
  {
    num: "02",
    title: "Set your preferences",
    desc: "Choose age range, location, and interests that matter most. We narrow the field.",
  },
  {
    num: "03",
    title: "Discover & connect",
    desc: "Browse profiles and like the ones that catch your eye. When it's a connection — the conversation starts.",
  },
  {
    num: "04",
    title: "Chat privately",
    desc: "Start a real conversation. Build something genuine from your very first message.",
  },
];

function StepIcon({ index }: { index: number }) {
  const icons = [
    <path key="a" d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />,
    <path key="b" d="M4 6h16M4 12h10M4 18h6" />,
    <path
      key="c"
      d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
    />,
    <path
      key="d"
      d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
    />,
  ];
  const extras = [
    <circle key="e" cx="12" cy="7" r="4" />,
    <circle key="f" cx="18" cy="17" r="3" />,
    null,
    null,
  ];
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      className="w-6 h-6"
    >
      {icons[index]}
      {extras[index]}
    </svg>
  );
}

export default function HowItWorks() {
  return (
    <section className="py-16 lg:py-[100px] px-[5%]" id="how-it-works">
      <Reveal>
        <Eyebrow>How it works</Eyebrow>
      </Reveal>
      <Reveal delay={100}>
        <h2 className="text-[clamp(28px,4vw,44px)] font-bold tracking-[-1.2px] leading-tight mb-8 lg:mb-[60px]">
          Four steps to your connection
        </h2>
      </Reveal>
      <StaggerReveal className="grid grid-cols-2 lg:grid-cols-4">
        {stepData.map((s) => (
          <div
            key={s.num}
            className="py-6 px-3 sm:py-10 sm:px-8 lg:border-l lg:border-black/8 lg:first:border-l-0 group"
          >
            <span className="text-[11px] font-medium tracking-[2px] text-muted uppercase mb-4 sm:mb-6 block">
              Step {s.num}
            </span>
            <div className="w-[52px] h-[52px] rounded-[14px] bg-blush flex items-center justify-center mb-5 text-rose-dark group-hover:scale-110 group-hover:rotate-[-4deg] group-hover:bg-blush-mid transition-all duration-300">
              {<StepIcon index={stepData.indexOf(s)} />}
            </div>
            <h3 className="text-base sm:text-lg font-semibold tracking-tight mb-2.5">
              {s.title}
            </h3>
            <p className="text-[13px] sm:text-sm text-muted leading-relaxed">
              {s.desc}
            </p>
          </div>
        ))}
      </StaggerReveal>
    </section>
  );
}
